import {message,Col, Input, Layout, Row, Tooltip, Upload, Button } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { Content } from 'antd/lib/layout/layout';
import { RouteComponentProps } from 'react-router';
import * as constants from '../../../constants/constants';
import { sendHttpPostRequest } from '../../../api/http-request';

import React, {useEffect, useRef, useState} from "react";

interface  Props extends  RouteComponentProps<{ video_id: string }> {
    video_id: string
}

import myStyles from "./oam-chapter.module.less";
import {PlusOutlined} from '@ant-design/icons';  

import OAMSider from '../oam-sider';
import Cookies from 'js-cookie';

/** 教室编辑页 */
export const OAMClassRoomEdit: React.FC<Props> = (props) => {
    const chapter_id = props.location.search.split("=")[1]
    
    const [name, setName] = useState("");//章节名称
    const [description, setDescription] = useState("");//章节介绍


    useEffect(() => {
      queryChapter();
  }, [])


    /**
     * 更新章节
     */
     const updateChapter = () => {
      sendHttpPostRequest(
          'course/api/oam_update_chapter',
          {
              sessionid: Cookies.get("sessionid"),
              chapter_id: chapter_id,
              name: name,
              description: description,
          },
          updateChapterCallback
      )
  }

  /**
   * 更新章节回调
   * @param response
   */
  const updateChapterCallback = (response: any) => {
      // console.log(response)
      message.destroy();
      if (response.code == -100) {
          // 未登录
          window.location.href = '/oam_login?next=oam_chapter';
      } else if (response.is_ok == true) {
          // 成功
          //setChapterId(response.chapter_id);
          message.success("章节" + response.chapter_id + "保存成功~")
         
      } /*else if (response.code == -501) {
          // 权限不足
          window.location.href = '/oam_login?next=oam_chapter';
      } */else {
          message.error(response.message);
      }
  }
 
   /**
     * 查询章节
     */
    const queryChapter = () => {
      sendHttpPostRequest(
          'course/api/oam_query_chapter_by_id',
          {
              sessionid: Cookies.get("sessionid"),
              chapter_id: chapter_id,
          },
          queryChapterCallback
      )
  }

  /**
   * 查询章节回调
   * @param response
   */
  const queryChapterCallback = (response: any) => {
      // console.log(response)
      message.destroy();
      if (response.code == -100) {
          // 未登录
          window.location.href = '/oam_login?next=oam_chapter';
      } else if (response.is_ok == true) {
          // 成功
          setName(response.query_info?.name)
          setDescription(response.query_info?.description)
          //message.success(response.chapter_id)
         
      } /*else if (response.code == -501) {
          // 权限不足
          window.location.href = '/oam_login?next=oam_chapter';
      } */else {
          message.error(response.message);
      }
  }
 


    return (
        <Layout style={{ minHeight: '100vh' }}>
        <OAMSider keys={"8"} openKeys={["sub-project"]}  ></OAMSider>
        <div>
            <Content style={{ minHeight: '90vh',backgroundColor:'#fff',borderRadius:5,width:800,margin:30 ,paddingTop:20}}>
            <div style={{paddingLeft:80,paddingRight:80}}>

            <Row gutter={[8,8]} justify='end'  align='middle' style={{marginBottom:20}} >
                    <Col  span={24} style={{color:"#00000073",textAlign:'right'}}>
                        <Button onClick={()=>{updateChapter()}} style={{borderRadius:20,width:80}} type="primary">保 存</Button>
                        </Col>       
                </Row>

                <Row gutter={[8,8]} justify='start'  align='middle' style={{marginBottom:20}} >
                    <Col flex="80px" style={{color:"#00000073",textAlign:'left'}}>名称</Col>
                    <Col flex="auto" style={{textAlign:'left'}}>
                        <Input placeholder="请输入章节名称" 
                        required={true} 
                        value = {name} 
                        onChange={(e)=>{setName(e.target.value)}} 
                        style={{borderRadius:3,width:"100%"}}/>
                    </Col>
                </Row>


                <Row gutter={[8,8]} justify='start'  align='top' style={{marginBottom:20}} >
                    <Col flex="80px" style={{color:"#00000073",textAlign:'left'}}>介绍</Col>
                    <Col flex="auto" style={{textAlign:'left'}}>
                        <TextArea placeholder="请输入章节介绍" 
                        style = {{borderRadius:3,width:"100%"}} 
                        autoSize = {{minRows: 5}} 
                        value = {description} 
                        onChange={(e)=>{setDescription(e.target.value)}} 
                        />

                    </Col>
                </Row>




            </div>
  
            </Content>
        </div>
    </Layout>
    )

}

export default OAMClassRoomEdit

